<app-header [seriesUrl]="redirectUrl"></app-header>

<div class="wrapper">
  <div
    [ngClass]="{
      'padding-remove': seasons[season_index]?.episodes[episode_index]
    }"
  >
    <div
      class="detail-page"
      [ngClass]="{ 'cus-playing': isPlaying || service.isShow }"
    >
      <app-poster-simmer *ngIf="shimmerStatus.poster"></app-poster-simmer>
      <app-document-detail
        *ngIf="document && !shimmerStatus.poster"
        [document_id]="document_id"
        [videoDetail]="seasons[season_index]?.episodes[episode_index]"
      ></app-document-detail>

      <section class="video-detail" *ngIf="!shimmerStatus.poster && !document">
        <div
          class="player"
          *ngIf="
            videoDetail.videoStatus &&
            loading_player &&
            seasons[season_index]?.episodes.length > 0 &&
            !videoDetail.bannerStatus
          "
        >
          <app-vjs-player
            (playerStatus)="videoStatus($event)"
            [options]="{
              autoplay: autoplay,
              aspectRatio: '16:9',
              poster: thumbnails,
              sources: [
                {
                  src: output_url,
                  type: 'application/x-mpegURL'
                }
              ],
              controls: true,
              loop: false,
              bigPlayButton: true,
              videoDetail: seasons[season_index]?.episodes[episode_index],
              redirectUrl: redirectUrl
            }"
          >
            <!-- withCredentials: true -->
          </app-vjs-player>
          <!-- <div *ngIf="
              (
                seasons[season_index]?.episodes[episode_index]?.view_days
                | viewdays: videoDetail?.current_date
              ).isLock
            " class="playerlock">
            <span class="mdi mdi-lock"></span>
          </div> -->
        </div>
        <div class="video" *ngIf="loading_player && videoDetail.bannerStatus">
          <app-content-subscription
            [videoDetail]="videoDetail"
          ></app-content-subscription>
        </div>
        <div
          *ngIf="!loading_player && !shimmerStatus.poster"
          class="video-not-support"
        >
          <img [src]="app_constant.BrowserNotSupported" />
          <h4 *ngIf="access">
            {{ "VIDEO_DETAIL.MESSAGE1" | translate }}
          </h4>
          <h4 *ngIf="!access">
            {{ "VIDEO_DETAIL.MESSAGE" | translate }}
          </h4>
        </div>
        <div *ngIf="!loading_player && !videoDetail" class="video-not-support">
          <img [src]="app_constant.BrowserNotSupported" />
          <h4>{{ "VIDEO_DETAIL.MESSAGE2" | translate }}</h4>
        </div>
      </section>
      <div
        class="video-content"
        *ngIf="
          seasons[season_index]?.episodes[episode_index] &&
          !shimmerStatus.poster
        "
      >
        <div class="container">
          <div class="banner-content-box">
            <app-video-info
              [videoDetail]="seasons[season_index]?.episodes[episode_index]"
              [url]="encodeUrl"
              [public_id]="public_id"
            ></app-video-info>
          </div>
        </div>
      </div>
      <section class="container" *ngIf="seasons.length > 1">
        <div class="section-head col-12">
          <h2>Contents</h2>
        </div>
        <mat-tab-group
          animationDuration="1ms"
          [(selectedIndex)]="selectedIndex"
        >
          <div *ngFor="let season of videoDetail.seasons; let i = index">
            <div class="detail-page" *ngIf="season.episodes.length > 0">
              <mat-tab label="{{ season?.title | titlecase }}">
                <div class="related-search">
                  <div class="row custome-set pl-2" *ngIf="isTabLoad">
                    <div
                      class="series-box"
                      *ngFor="let episode of season.episodes; let j = index"
                    >
                      <div>
                        <div
                          [routerLink]="['/series', videoDetail.public_id]"
                          [queryParams]="{ episode: episode.public_id }"
                        >
                          <div *ngIf="episode?.thumbnails?.length > 0">
                            <div
                              class="ratio-slider ratio-16-9 view-content"
                              [ngClass]="{
                                watching:
                                  episode.public_id !== episode_id &&
                                  episode.extension !== 'document',
                                'document-watching':
                                  episode.public_id !== episode_id &&
                                  episode.extension === 'document'
                              }"
                            >
                              <img
                                src="{{
                                  episode?.thumbnails | thumbnails: 'landscape'
                                }}"
                                [src-fallback]="app_constant.landscapeDefault"
                              />
                              <div class="overlay">
                                <a href="javascript:void(0)" class="btn-play">
                                  <span class="icon-play-button"></span>
                                </a>
                              </div>
                              <!-- <div *ngIf="
                                  (
                                    episode?.view_days
                                    | viewdays: videoDetail?.current_date
                                  ).isLock
                                " class="lock-video-box" matTooltip="This content will active after {{
                                  (
                                    episode?.view_days
                                    | viewdays: videoDetail?.current_date
                                  ).leftDays
                                }} days" matTooltipPosition="above">
                                <span class="mdi mdi-lock"></span>
                              </div> -->
                              <div
                                class="progress mb-2"
                                *ngIf="
                                  episode.public_id === episode_id &&
                                  episode?.type == 'series' &&
                                  episode?.view_duration > 0
                                "
                              >
                                <div
                                  class="progress-bar"
                                  role="progressbar"
                                  [ngStyle]="{
                                    width:
                                      (episode?.view_duration /
                                        episode?.total_duration) *
                                        100 +
                                      '%'
                                  }"
                                  aria-valuenow="25"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                            <div class="slider-titles">
                              <h5 class="title">
                                <a class="href"> E {{ j + 1 }}: </a>
                                {{ episode.name }}
                              </h5>
                              <p class="sub-title">
                                <span *ngIf="episode.duration">
                                  {{ episode.duration | second_time }}
                                </span>
                              </p>
                            </div>
                          </div>

                          <div *ngIf="episode?.thumbnails?.length == 0">
                            <div
                              class="ratio-slider ratio-16-9"
                              [ngClass]="{
                                watching:
                                  episode.public_id !== episode_id &&
                                  episode.extension !== 'document',
                                'document-watching':
                                  episode.public_id !== episode_id &&
                                  episode.extension === 'document'
                              }"
                            >
                              <!-- [ngClass]="{
                                watching: j == episode_id
                              }" -->
                              <img [src]="app_constant.landscapeDefault" />
                              <!-- <div *ngIf="
                                  (
                                    episode?.view_days
                                    | viewdays: videoDetail?.current_date
                                  ).isLock
                                " class="lock-video-box" matTooltip="This content will active after {{
                                  (
                                    episode?.view_days
                                    | viewdays: videoDetail?.current_date
                                  ).leftDays
                                }} days" matTooltipPosition="above">
                                <span class="mdi mdi-lock"></span>
                              </div> -->
                            </div>

                            <div
                              class="progress mb-2"
                              *ngIf="
                                episode.public_id === episode_id &&
                                episode?.type == 'series' &&
                                episode?.view_duration > 0
                              "
                            >
                              <div
                                class="progress-bar"
                                role="progressbar"
                                [ngStyle]="{
                                  width:
                                    (episode?.view_duration /
                                      episode?.total_duration) *
                                      100 +
                                    '%'
                                }"
                                aria-valuenow="25"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                            <div class="slider-titles">
                              <h5 class="title">
                                <a class="href"> E {{ j + 1 }}: </a>
                                {{ episode.name }}
                              </h5>
                              <p class="sub-title">
                                <span *ngIf="episode.duration">
                                  {{ episode.duration | second_time }}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </div>
          </div>
        </mat-tab-group>
      </section>

      <div class="home-page mt-3" *ngIf="seasons.length <= 1">
        <section class="container mb-3">
          <div class="slider" *ngIf="seasons[0]?.episodes.length > 0">
            <div class="section-head ng-star-inserted">
              <div class="section-head col-12">
                <h2>Contents</h2>
              </div>
              <!-- <a href="javascript:void(0)" class="text-primary view-all-link">
               {{ "HOME.VIEW_ALL" | translate }}
              </a> -->
            </div>
            <owl-carousel-o [options]="customOptionsvideo">
              <ng-container
                *ngFor="let episode of seasons[0]?.episodes; let j = index"
              >
                <ng-template carouselSlide>
                  <div
                    class="series-box"
                    [routerLink]="['/series', videoDetail.public_id]"
                    [queryParams]="{ episode: episode.public_id }"
                  >
                    <div *ngIf="episode?.thumbnails?.length > 0">
                      <div>
                        <div
                          class="ratio-slider ratio-16-9 view-content"
                          [ngClass]="{
                            watching:
                              episode.public_id !== episode_id &&
                              episode.extension !== 'document',
                            'document-watching':
                              episode.public_id !== episode_id &&
                              episode.extension === 'document'
                          }"
                        >
                          <img
                            src="{{
                              episode?.thumbnails | thumbnails: 'landscape'
                            }}"
                            [src-fallback]="app_constant.landscapeDefault"
                          />
                          <div class="overlay">
                            <a href="javascript:void(0)" class="btn-play">
                              <span class="icon-play-button"></span>
                            </a>
                          </div>

                          <!-- <div *ngIf="
                              (
                                episode?.view_days
                                | viewdays: videoDetail?.current_date
                              ).isLock
                            " class="lock-video-box" matTooltip="This content will active after {{
                              (
                                episode?.view_days
                                | viewdays: videoDetail?.current_date
                              ).leftDays
                            }} days" matTooltipPosition="above">
                            <span class="mdi mdi-lock"></span>
                          </div> -->
                        </div>
                        <div
                          class="progress mb-2"
                          *ngIf="
                            (episode.public_id === episode_id ||
                              episode.public_id !== episode_id) &&
                            episode?.type == 'series' &&
                            episode?.view_duration > 0
                          "
                        >
                          <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{
                              width:
                                (episode?.view_duration /
                                  episode?.total_duration) *
                                  100 +
                                '%'
                            }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <div class="slider-titles">
                          <h5 class="title">
                            <a class="href"> E {{ j + 1 }}: </a>
                            {{ episode.name | titlecase }}
                          </h5>
                          <p class="sub-title" *ngIf="episode.duration">
                            {{ episode.duration | second_time }}
                            <!-- <span class="dots"></span> -->
                          </p>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="episode?.thumbnails?.length == 0">
                      <div
                        class="ratio-slider ratio-16-9"
                        [ngClass]="{
                          watching:
                            episode.public_id !== episode_id &&
                            episode.extension !== 'document',
                          'document-watching':
                            episode.public_id !== episode_id &&
                            episode.extension === 'document'
                        }"
                      >
                        <!-- [ngClass]="{
                          watching: j == episode_id
                        }" -->
                        <!-- {{episode?.view_days}}
                        {{episode?.view_days
                          | viewdays: videoDetail?.current_date}} -->
                        <img [src]="app_constant.landscapeDefault" />
                        <!-- <div *ngIf="
                              (
                                episode?.view_days
                                | viewdays: videoDetail?.current_date
                              ).isLock
                            " class="lock-video-box" matTooltip="This content will active after {{
                              (
                                episode?.view_days
                                | viewdays: videoDetail?.current_date
                              ).leftDays
                            }} days" matTooltipPosition="above">
                          <span class="mdi mdi-lock"></span>
                        </div> -->
                      </div>

                      <div
                        class="progress mb-2"
                        *ngIf="
                          (episode.public_id === episode_id ||
                            episode.public_id !== episode_id) &&
                          episode?.type == 'series' &&
                          episode?.view_duration > 0
                        "
                      >
                        <div
                          class="progress-bar"
                          role="progressbar"
                          [ngStyle]="{
                            width:
                              (episode?.view_duration /
                                episode?.total_duration) *
                                100 +
                              '%'
                          }"
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div class="slider-titles">
                        <h5 class="title">
                          <a class="href"> E {{ j + 1 }}: </a>
                          {{ episode.name }}
                        </h5>
                        <p class="sub-title">
                          <span *ngIf="episode.duration">
                            {{ episode.duration | second_time }}
                          </span>

                          <!-- <span class="dots"></span> -->
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </section>
      </div>
      <app-grid-simmer *ngIf="shimmerStatus.relatedvideo"></app-grid-simmer>
      <section class="related-search" *ngIf="relatedSeries?.length > 0">
        <div class="container" *ngIf="!shimmerStatus.relatedvideo">
          <div class="">
            <div class="section-head col-12">
              <h2>{{ "VIDEO_DETAIL.RELATED_SERIES" | translate }}</h2>
            </div>
          </div>
          <div class="row custome-set">
            <div class="series-box" *ngFor="let show of relatedSeries">
              <app-grid [data]="show" [gridType]="'landscape'"></app-grid>
            </div>
          </div>
        </div>
      </section>
      <app-genre-slider></app-genre-slider>
    </div>
  </div>
</div>
<app-footer></app-footer>
